/**
 * external dependencies
 */
import { TabulatorFull } from 'tabulator-tables';

/**
 * internal dependencies
 */
import { ICards } from '../../../models/cards.interface';
import { FILTER_SECTION } from '../common/filter-elements';
import { handleFilterSectionToggle } from "../common/filter-section-toggle";
import { filterClear } from "../common/filter-clear";
import { cardGroupDropDown } from '../common/card-group-dropdown';

/**
 * Function that handles the table filter for the card list table.
 * 
 * @param {TabulatorFull} tableObject the table class instance
 * 
 * @returns void
 */
export const cardListTableFilter = (tableObject: TabulatorFull) => {
  if ( typeof tableObject != 'object' || tableObject === null || tableObject === undefined ) return;

  let { data: tableData } = tableObject.options as { data: ICards[] };
  cardGroupDropDown(tableData);

  handleFilterSectionToggle(".aafp_filter-header");
  // handles searching the table
  FILTER_SECTION.searchFilterButton!.addEventListener('click', () => {
    searchCardGroupTable(tableObject);
  });

  // handles clearing all filter inputs and clearing the table of the search results
  FILTER_SECTION.clearFilterButton!.addEventListener('click', () => {
    filterClear('.table-filter-clear');
    tableObject.clearFilter(true);
  });
}

/**
 * Get data from input fields and sets a filter on the table object. This function cannot be put into
 * the table-helpers file due to different amount of fields that can be used as a filter.
 * 
 * @param {TabulatorFull} table the table class instance. 
 * 
 * @returns void
 */
const searchCardGroupTable = (table: TabulatorFull) => {
  const customer = document.querySelector('#aafp_customer-list-sort') as HTMLInputElement;
  const card = document.querySelector('#aafp_card-number-sort') as HTMLInputElement;
  const group = document.querySelector('#aafp_dropdown-button-two') as HTMLInputElement;
  const name = document.querySelector('#aafp_cardname-list-sort') as HTMLInputElement;
  const filterArr: object[] = [];

  if ( card.value != '' ) {
    filterArr.push({field: 'cardNumber', type: 'like', value: card.value});
  }

  if (customer.value != '') {
    filterArr.push({field: 'customerName', type: 'like', value: customer.value});
  }

  if(typeof group.dataset.value !== 'undefined' &&  group.dataset.value !== '') {
    filterArr.push({field: 'cardGroupId', type: '=', value: group.dataset.value});
  }

  if ( name.value != '' ) {
    filterArr.push({field: 'cardName', type: 'like', value: name.value});
  }

  table.setFilter(filterArr);
}